export function createClassNameString(classNameArray) {
  return classNameArray.filter((className) => !!className).join(" ");
}
